import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SEOHead from '../SEOHead';
import DesktopNavigation from '../Navigation/DesktopNavigation';
import MobileNavigation from '../Navigation/MobileNavigation';
import Footer from '../Footer/Footer';

const PrivacyPolicyPage: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans overflow-x-hidden selection:bg-[#05a5b7] selection:text-white flex flex-col">
      <SEOHead 
        title={`${t('privacyPolicyPage.title')} | Christ Reigns Media`}
        description={t('privacyPolicyPage.intro')}
      />
      
      <DesktopNavigation />
      <MobileNavigation />
      
      <main className="flex-grow pt-24 xl:pt-32 pb-20">
        <div className="container mx-auto px-6 md:px-8 max-w-4xl">
          
          {/* Header */}
          <div className="border-b border-gray-200 pb-8 mb-12">
            <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900 mb-4">
              {t('privacyPolicyPage.title')}
            </h1>
            <p className="text-sm text-[#05a5b7] font-bold uppercase tracking-wider font-mono">
              {t('privacyPolicyPage.lastUpdated')}
            </p>
          </div>

          {/* Intro */}
          <p className="text-lg text-gray-700 leading-relaxed mb-10 font-light">
            {t('privacyPolicyPage.intro')}
          </p>

          {/* Policy Sections */}
          <div className="space-y-12">
            {/* Section 1 */}
            <section className="space-y-4">
              <h2 className="text-2xl font-bold tracking-tight text-gray-900">
                {t('privacyPolicyPage.section1Title')}
              </h2>
              <div className="text-gray-700 space-y-4 leading-relaxed">
                <p>{t('privacyPolicyPage.section1P1')}</p>
                <p>{t('privacyPolicyPage.section1P2')}</p>
              </div>
            </section>

            {/* Section 2 */}
            <section className="space-y-4">
              <h2 className="text-2xl font-bold tracking-tight text-gray-900">
                {t('privacyPolicyPage.section2Title')}
              </h2>
              <div className="text-gray-700 space-y-4 leading-relaxed">
                <p>{t('privacyPolicyPage.section2Intro')}</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>{t('privacyPolicyPage.section2Bullet1')}</li>
                  <li>{t('privacyPolicyPage.section2Bullet2')}</li>
                  <li>{t('privacyPolicyPage.section2Bullet3')}</li>
                </ul>
                <p>{t('privacyPolicyPage.section2Outro')}</p>
              </div>
            </section>

            {/* Section 3 */}
            <section className="space-y-4">
              <h2 className="text-2xl font-bold tracking-tight text-gray-900">
                {t('privacyPolicyPage.section3Title')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('privacyPolicyPage.section3Text')}
              </p>
            </section>

            {/* Section 4 */}
            <section className="space-y-4">
              <h2 className="text-2xl font-bold tracking-tight text-gray-900">
                {t('privacyPolicyPage.section4Title')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('privacyPolicyPage.section4Text')}
              </p>
            </section>

            {/* Section 5 */}
            <section className="space-y-4">
              <h2 className="text-2xl font-bold tracking-tight text-gray-900">
                {t('privacyPolicyPage.section5Title')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('privacyPolicyPage.section5Text')}
              </p>
            </section>

            {/* Section 6 */}
            <section className="space-y-4">
              <h2 className="text-2xl font-bold tracking-tight text-gray-900">
                {t('privacyPolicyPage.section6Title')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('privacyPolicyPage.section6Text')}
              </p>
            </section>

            {/* Section 7 */}
            <section className="space-y-4">
              <h2 className="text-2xl font-bold tracking-tight text-gray-900">
                {t('privacyPolicyPage.section7Title')}
              </h2>
              <div className="text-gray-700 space-y-4 leading-relaxed">
                <p>{t('privacyPolicyPage.section7Text')}</p>
                <div className="bg-gray-50 border border-gray-150 p-6 rounded-2xl inline-block">
                  <p className="text-sm font-semibold text-gray-900">
                    {t('privacyPolicyPage.emailLabel')}:{' '}
                    <a 
                      href="mailto:chist.reigns.m@gmail.com" 
                      className="text-[#05a5b7] hover:underline"
                    >
                      chist.reigns.m@gmail.com
                    </a>
                  </p>
                </div>
              </div>
            </section>
          </div>

        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
